import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-pending-payment-check-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule, TranslateModule],
  templateUrl: "./pending-payment-check-dialog.component.html",
  styleUrls: ["./pending-payment-check-dialog.component.scss"],
})
export class PendingPaymentCheckDialogComponent {}
